module.exports = __webpack_public_path__ + "fonts/subset-Axiforma-SemiBold.ceb5117.woff";